const assets = {
  payPayLogo: "/paypay_logo_white.png",
  heroImage: "/higurashi/hero_image.webp",
};

export default assets;
